import { Section } from '../components/Sider/interface'

const sideData: Section[] = [
    {
        title: '工作台',
        icon: 'workbench',
        href: '/v4/workspace'
    },
    {
        title: '帮助中心',
        icon: 'help',
        href: '//wiki.kuaizhan.com/pub/%E9%A6%96%E9%A1%B5',
        linkType: 'outer'
    },
    // {
    //     title: '站内消息',
    //     icon: 'information',
    //     href: '/v4/TODO'
    // },
]

export default sideData;